<template>
  <div ref="researchLinkRef" class="research-link-container">
    <p v-html="researchLinkContent"></p>
  </div>
</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

export default {
  props: {
    researchLinkContent: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleResearchLinkClick(event) {
      if (this.$store.state.appConfig.is_embedded_in_mh_app && event.target.tagName === "A") {
        event.preventDefault();
        const href = event.target.getAttribute("href");
        communicationService.sendTriggerToParent({ key: dataKeys.MOBILE_APP_OPEN_EXTERNAL_LINK, value: href });
      }
    },
  },
  mounted() {
    this.$refs.researchLinkRef.addEventListener("click", this.handleResearchLinkClick);
  },
  beforeDestroy() {
    this.$refs.researchLinkRef.removeEventListener("click", this.handleResearchLinkClick);
  },
}
</script>

<style lang="scss" scoped>
.research-link-container {
  display: inline-block;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>
